<script lang="ts"> 
    import { Form } from "svelte-forms-lib";
    import { Button, Col, FormGroup, Input, Label, Row } from "sveltestrap";
    import { AccountInformation, BillingInformation, Cancel, CompanyInformation, CompanyName, ContactNumber, EmailAddress, Megaform, Submit, Website, YourName } from "../../../../utils/Constant/Constant";
    import Card from "../../../Core/Card.svelte";
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={Megaform}>
      <div slot="contentbody">
        <Form class="theme-form mega-form">
          <h6>{AccountInformation}</h6>
          <FormGroup>
            <Label class="col-form-label">{YourName}</Label>
            <Input type="text" placeholder="your Name" />
          </FormGroup>
          <FormGroup>
            <Label class="col-form-label">{EmailAddress}</Label>
            <Input type="email" placeholder="Enter email" />
          </FormGroup>
          <FormGroup>
            <Label class="col-form-label">{ContactNumber}</Label>
            <Input type="Number" placeholder="Enter contact number" />
          </FormGroup>
          <hr class="mt-4 mb-4">
          <h6>{CompanyInformation}</h6>
          <FormGroup>
            <Label class="col-form-label">{CompanyName}</Label>
            <Input type="text" placeholder="Company Name" />
          </FormGroup>
          <FormGroup>
            <Label class="col-form-label">{Website}</Label>
            <Input type="text" placeholder="Website" />
          </FormGroup>
        </Form>
        <hr class="mt-4 mb-4">
        <h6 class="pb-3 mb-0">{BillingInformation}</h6>
        <Form class="form-space theme-form">
          <Row>
            <div class="col-auto">
              <Input type="text" placeholder="Name On Card" />
            </div>
            <div class="col-auto">
              <Input type="text" name="inputPassword" placeholder="Card Number" />
            </div>
            <div class="col-auto">
              <Input type="text" name="inputPassword" placeholder="Zip Code" />
            </div>
          </Row>
        </Form>
      </div>
      <div slot="contentfooter">
        <Button color="primary" >{Submit}</Button>
        <Button color="secondary">{Cancel}</Button>
      </div>
    </Card>
</Col>